export  const generateWhatsAppLink = () => {
  const phoneNumber = '+917042696105'; // Replace this with the phone number you want to message
  const message = 'Hi Commbitz, I want to buy an eSIM for my international trip!'; // Replace this with the message you want to send

  return `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
};